import type { ILocaleLang } from "../../app/types/appReducer.t";

export const DEFAULT_LOCALE_LANG_ITEM: ILocaleLang = {
    fullName: '',
    name: '',
    value: '',
} as const;
